<div (click)="handlerOrder()" class="flex gap-4 items-center justify-start">
  <ng-content></ng-content>
  <l-icon *ngIf="simpleOrder === -1" class="text-color !text-xl" icon="arrow_upward" />
  <l-icon *ngIf="simpleOrder === 1" class="text-color !text-xl" icon="arrow_downward" />
  <l-icon *ngIf="simpleOrder === 0" class="text-color !text-xl opacity-50" icon="swap_vert" />
</div>
